import qs from 'qs'
import { createMatchSelector } from 'react-router-redux'
import { createSelector } from 'reselect'
import { convertToModeId } from 'tickets/utils/modes'
import { NO_RESULTS_MODE } from 'tickets/utils/constants'
import { dateFormat } from 'common/utils/time'
import moment from 'moment'

import {
  getCleanOutboundDateFromUrl,
  getCleanInboundDateFromUrl,
  getCleanPaxFromUrl,
  buildUrl,
  getDebugFlagsFromUrl,
} from 'tickets/utils/urlUtils'
import { ticketsSearchPath } from 'common/utils/paths'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'

const getRouteSearchParams = (state) => (
  (state.router.location)
    ? qs.parse(state.router.location.search.slice(1))
    : ''
)

const getRoute = state => createMatchSelector({ path: ticketsSearchPath })(state).params

const getSearchOrigin = (state) => getRoute(state).origin
const getSearchDestination = (state) => getRoute(state).destination

const getSearchOutboundDateTime = (state) =>
  getCleanOutboundDateFromUrl(getRouteSearchParams(state).oDateTime)
const getSearchInboundDateTime = (state) =>
  getCleanInboundDateFromUrl(getRouteSearchParams(state).iDateTime)

const getCurrentModeId = (state) => {
  const currentModeId = getRouteSearchParams(state).mode
  return (currentModeId == NO_RESULTS_MODE) ? NO_RESULTS_MODE : convertToModeId(currentModeId)
}

const getSearchPax = () => getCleanPaxFromUrl() // This should be turned into a selector

const getSelectedOutboundItineraryId = createSelector(
  [getRouteSearchParams],
  (routeSearchParams) => routeSearchParams.oid
)

const getSelectedInboundItineraryId = createSelector(
  [getRouteSearchParams],
  (routeSearchParams) => routeSearchParams.iid
)

const getCurrentSearchURL = createSelector(
  [
    getSearchOrigin,
    getSearchDestination,
    getSearchOutboundDateTime,
    getSearchInboundDateTime,
    getLanguageCode,
  ],
  (
    origin,
    destination,
    oDateTime,
    iDateTime,
    languageCode,
  ) => buildUrl(
    origin,
    destination,
    moment(oDateTime, dateFormat),
    iDateTime ? moment(iDateTime, dateFormat) : null,
    getSearchPax(),
    getDebugFlagsFromUrl(),
    languageCode,
  )
)

export {
  getSearchOrigin,
  getSearchDestination,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
  getSearchPax,
  getRouteSearchParams,
  getRoute,
  getSelectedOutboundItineraryId,
  getSelectedInboundItineraryId,
  getCurrentModeId,
  getCurrentSearchURL,
}
